import axios from 'axios'
import { CommonFilterModel, CommonResource } from '@/api/resources/common/shared/models/common.models'
import { EnumResponse } from '@/api/services/common.dto'

class BatchReportServices {
    async generateReportsFromPatientsCases(batchReportCaseStatus: string, encoded: boolean, filterModel: CommonFilterModel, laboratoryId: number, params: any): Promise<CommonResource> {
        const reportParams = {
            ...params,
            batchReportCaseStatus,
            laboratoryId,
            encoded
        }
        const response = await axios.put<CommonResource>(`/registry/batch/reports/patients`, filterModel, { params: reportParams })
        return response.data
    }

    async generateReportsFromApaReports(batchReportCaseStatus: string, encoded: boolean, filterModel: CommonFilterModel, laboratoryId: number): Promise<CommonResource> {
        const params = {
            batchReportCaseStatus,
            encoded
        }
        const response = await axios.put<CommonResource>(`/registry/laboratories/${laboratoryId}/batch/cases/reports`, filterModel, { params })
        return response.data
    }

    async getAllCaseStatesForBatchReports(laboratoryId: number): Promise<EnumResponse[]> {
        const params = { laboratoryId: laboratoryId }
        const response = await axios.get<EnumResponse[]>(`/registry/batch/report/caseStates`, { params })
        return response.data
    }
}

export const batchReportServices = new BatchReportServices()
